import { AbstractWSService } from "./ws.service";
import { ChatHandler } from "@/services/socket/handler/chat.handle.service";
import type { WSConnection } from "@/plugins/ws.connection";

export class ChatService extends AbstractWSService {
  constructor(connection: WSConnection) {
    const chatHandler = new ChatHandler();

    super(connection, {
      eventHandler: (data: any) => {
        chatHandler.handleWSData(data);
      },
      async recoveryHandler(lastEvent) {
        await chatHandler.recoveryHandler(lastEvent);
      },
      onlineStatusHandler(isOnline) {
        chatHandler.onlineStatusHandler(isOnline);
      },
    });
  }

  sendMessagesUpdate(threadId: number, limit: number, timeFrom: string | null = null) {
    const payload = {
      threadId,
      limit,
      ...(timeFrom ? { timeFrom } : {}),
    };

    this.sendCommand("messages", payload);
  }
}
